<template>
  <div>
    <div
      v-html="htmlNotification"
      v-if="showNotification"
    >
    </div>
    <p>
      <button
        class="btn btn-primary"
        @click.prevent="downloadSNSData"
      >
        Download
      </button>
    </p>
  </div>
</template>
<script>
export default {
  computed: {
    htmlNotification () {
      return require('json2html').render(JSON.parse(this.notification))
    }
  },

  props: {
    showNotification: {
      type: Boolean
    },

    notification: {
      type: String,
      required: true
    }
  },

  mounted () {
    this.showNotification = this.showNotification !== undefined
  },

  methods: {
    downloadSNSData () {
      this.$root.downloadJSON(JSON.parse(this.last_sns), {
        downloadName: 'recipient-sns-' + this.id
      })
    }
  }
}
</script>
<style>
  #j2h .j2hvalue {
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/components/EmailRecipientNotification.vue